var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EnrollExamSubjectSetting',{staticClass:"write_exam_query_date",attrs:{"custom-id":_vm.customId,"data-types":_vm.dataTypes},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('keep-alive',[_c('TemplateDataGrid',_vm._b({attrs:{"gridId":"operaEnrollingExamSubjectList"}},'TemplateDataGrid',scope,false))],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }